import { createFileRoute } from "@tanstack/react-router"

import { LegalVersionPage } from "@/components/content/legal-version-page"
import {
  findLegalVersion,
  lazyLegalModules,
  loadLegalVersion,
  resolveLegalVersions,
} from "@/lib/legal-versions"
import { seoMeta } from "@/lib/seo"

const modules = lazyLegalModules(import.meta.glob("../-content/regions/*.md"))

export const Route = createFileRoute("/_content/regions/$date")({
  loader: ({ params }) => loadLegalVersion(modules, params.date),
  head: ({ loaderData }) => {
    if (!loaderData) return {}
    return seoMeta({
      title: `Hosting Regions (${loaderData.dateFormatted})`,
      description: `Archived version of the Entire Hosting Regions page from ${loaderData.dateFormatted}.`,
      url: `https://entire.com/regions/${loaderData.date}`,
      image: "https://entire.com/og/page/regions.png",
      noindex: true,
    })
  },
  component: RegionsVersionPage,
})

function RegionsVersionPage() {
  const { asOf, date } = Route.useLoaderData()
  const versions = resolveLegalVersions(modules, asOf)
  const version = findLegalVersion(versions, date)!
  return <LegalVersionPage basePath="/regions" version={version} versions={versions} />
}
